import { render, staticRenderFns } from "./wechatband.vue?vue&type=template&id=07b369c4&scoped=true"
import script from "./wechatband.vue?vue&type=script&lang=js"
export * from "./wechatband.vue?vue&type=script&lang=js"
import style0 from "./wechatband.vue?vue&type=style&index=0&id=07b369c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b369c4",
  null
  
)

export default component.exports